<template>
  <div id="sticky" class="navbar navbar-expand-md navbar-light" data-margin-top="0">
    <div class="text-center d-md-none w-100">
      <button type="button" class="navbar-toggler dropdown-toggle" data-toggle="collapse" data-target="#navbar-demo2-mobile">
        <i class="icon-menu7 mr-2"></i>
        {{ $t("menu") }}
      </button>
    </div>

    <div class="navbar-collapse collapse" id="navbar-demo2-mobile">
      <ul class="navbar-nav" v-click-outside="hide">
        <li class="nav-item">
          <div class="navbar-nav-link dropdown-toggle event-selector-badge" @click="showEventSelector = !showEventSelector">
            <div class="img" :style="'background-image:url(' + $imageus + $store.getters.currentEvent.logo + '?width=100&height=100&mode=contain)'"></div>
            <span>{{ $store.getters.currentEvent.title }}</span>
          </div>

          <div class="event-selector-wrapper" v-if="showEventSelector">
            <div class="event-selector-search">
              <el-input prefix-icon="fas fa-search" autofocus v-model="searchTerm" :placeholder="$t('searchEventName')" size="medium" clearable></el-input>
            </div>

            <div class="event-selector-container">
              <div class="event-selector-item" @click="switchEvent(item.id)" v-for="item in getEvents" :key="item.id">
                <div class="img" :style="'background-image:url(' + $imageus + item.logo + '?width=100&height=100&mode=contain)'"></div>
                <div class="event-selector-item-title">
                  <span>{{ item.title }}</span>
                  <div class="event-dates">
                    <div class="event-dates-start">
                      <i class="fas fa-calendar"></i>
                      {{ $moment(item.startDate).format("Do") + " " + $moment(item.startDate).format("MMM") + " " + $moment(item.startDate).format("YY") }}
                    </div>
                    <!-- <div class="event-dates-end">
                      <i class="el-icon-right"></i>
                      {{ $moment(item.endDate).format("Do") + " " + $moment(item.endDate).format("MMM") + " " + $moment(item.endDate).format("YY") }}
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <ul class="navbar-nav ml-md-auto" :style="$route.name == 'search' || $route.name == 'event' || $route.name == 'dashboard' ? 'max-width: 1140px;' : ''">
        <portal-target name="action-buttons"></portal-target>
      </ul>
    </div>
    <!-- 
      <el-dialog :title="$t('createNewEvent')" :visible.sync="createDialog" :append-to-body="true">
        <div class="card" style="padding: 10px 15px;margin:1rem">
          <div class="col-md-12 form-group">
            <el-input v-model="title" size="medium" :placeholder="$t('enterEventName')"></el-input>
          </div>
          <div class="col-md-12 mb-2">
            <el-button type="primary" @click="createEvent" :loading="loading" style="float: right">{{ $t('create') }}</el-button>
          </div>
        </div>
      </el-dialog> -->
  </div>
</template>

<script>
import Sticky from "sticky-js";
import $ from "jquery";
import axios from "axios";
import ClickOutside from "vue-click-outside";
import slugify from "slugify";
export default {
  name: "Breadcrumb",
  data() {
    return {
      createDialog: false,
      loading: false,
      title: null,
      search: false,
      showEventSelector: false,
      searchTerm: null
    };
  },
  async created() {
    this.eventWrapperLoading(false);
    this.$store.commit("resetDashboardAllData");
    await Promise.all([this.$store.dispatch("getOrganization"), this.$store.dispatch("getEvent"), this.$store.dispatch("getSubEvents"), this.$store.dispatch("getGroups"), this.$store.dispatch("getTags"), this.$store.dispatch("getRegisterForm")]);
    await this.setWhiteLabel();
    // await this.$store.dispatch('getEvent');
    // await this.$store.dispatch('getSubEvents');
    // await this.$store.dispatch('getGroups');
    // await this.$store.dispatch('getTags');
  },
  mounted() {
    $(document).on("click", ".open-url", function() {
      var id = $(this).attr("user-id");
      alert("profile ID : " + id);
      // window.vm.$root.$emit('getProfile', id);
    });

    this.$nextTick(() => {
      $("#header").css("position", "unset");
      $("#header").css("box-shadow", "unset");
      var navbar = document.getElementById("sticky");
      var dbody = document.body;
      var sticky = navbar.offsetTop;
      if (window.pageYOffset >= sticky) {
        $(navbar).addClass("stick");
        $(dbody).addClass("sticked");
      } else {
        $(navbar).removeClass("stick");
        $(dbody).removeClass("sticked");
      }
      $(document).scroll(e => {
        if (window.pageYOffset > sticky + 0) {
          $(navbar).addClass("stick");
          $(dbody).addClass("sticked");
        } else {
          $(navbar).removeClass("stick");
          $(dbody).removeClass("sticked");
        }
        $(document).scroll(e => {
          if (window.pageYOffset > sticky + 0) {
            $(navbar).addClass("stick");
            $(dbody).addClass("sticked");
          } else {
            $(navbar).removeClass("stick");
            $(dbody).removeClass("sticked");
          }
        });
      });
    });
  },
  directives: {
    ClickOutside
  },

  methods: {
    async getStatistics() {
      var res = await axios.post("Statistics/BasicStatistics", {});
      if (!res.data.alert.hasError) {
        this.statistics = res.data.data.items;
        console.log(this.statistics);
      }
    },
    hide() {
      this.showEventSelector = false;
    },
    async setWhiteLabel() {
      var instance = axios.create();
      instance.defaults.baseURL = "https://api.holacon.com/v2/";
      var res = await instance.post("/Definition/GetApplicationSettings", { id: this.organisation.defaultApplicationID });
      if (!res.data.hasError) {
        this.$store.commit('setWhiteLabelSettings',res.data.data);
      }
    },
    async switchEvent(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("login/switchevent", { id });
        if (!res.data.alert.hasError) {
          this.eventWrapperLoading(true);
          axios.defaults.headers["Authorization"] = "Bearer " + res.data.data.token;
          this.$store.state.user.token = res.data.data.token;
          localStorage.setItem("token", res.data.data.token);
          this.$router.push({ name: "event", params: { event_id: id } }).catch(() => {});
          // window.location.reload();
          this.$store.commit("setPrintSchemeId", null);
          this.$store.commit("setParticipantPage", 1);
          await Promise.all([this.$store.dispatch("getParticipants"), this.$store.dispatch("getEvent"), this.$store.dispatch("getSubEvents"),this.$store.dispatch("getOrganization"), this.$store.dispatch("getGroups"), this.$store.dispatch("getEventCategories"), this.$store.dispatch("getRegisterForm"), this.$store.dispatch("getAllTimeZones"), this.getStatistics()]);
          await this.setWhiteLabel();
          this.$store.state.eventdashboard.overview.data = null;
          this.eventWrapperLoading(false);
        } else {
          this.$message.error(res.data.alert.message);
        }
      }, 1000);
    },
    async createEvent() {
      this.loading = true;
      var res = await axios.post("event/create", { title: this.title });
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
        this.loading = false;
      } else {
        this.$message.success(res.data.alert.message);
        setTimeout(() => {
          this.switchEvent(res.data.data);
        }, 2000);
        this.loading = false;
      }
    }
  },
  computed: {
    organisation(){
      return  this.$store.getters.getCurrentOrganization
    },
    getSearchTerm() {
      return slugify(this.searchTerm == null ? "" : this.searchTerm, {
        replacement: " ",
        lower: true
      });
    },
    getEvents() {
      var regex = new RegExp(this.getSearchTerm, "g");
      if (this.getSearchTerm == null || this.getSearchTerm == "") return this.$store.state.event.events;
      return this.$store.state.event.events.filter(
        k =>
          slugify(k.title, " ")
            .toLowerCase()
            .match(regex) ||
          slugify(k.title, " ").match(regex) ||
          k.searchTerms.some(x =>
            slugify(x, " ")
              .toLowerCase()
              .match(regex)
          )
      );
    }
  }
};
</script>
<style lang="less" scoped>
#header {
  position: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue